export class GetProducts {
  constructor() {
    this._cards = document.querySelector('[data-cards]');
    this._list = null;
    this._showMoreButton = null;

    this._documentClickHandler = this._documentClickHandler.bind(this);
  }

  init() {
    if (!this._cards) {
      return;
    }

    this._list = this._cards.querySelector('[data-cards-list]');
    this._showMoreButton = this._cards.querySelector('[data-cards-show-more-button]');

    document.addEventListener('click', this._documentClickHandler);
  }

  _documentClickHandler(evt) {
    const target = evt.target;

    if (!target.closest('[data-cards-button]')) {
      return;
    }

    const currentButton = this._cards.querySelector('[data-cards-button].is-active');
    const button = target.closest('[data-cards-button]');
    const category = button.dataset.cardsButton;

    currentButton.classList.remove('is-active');
    button.classList.add('is-active');

    this._getProducts(category);
  }

  _getProducts(category) {
    const params = {
      category,
      action: 'get_products',
    };

    fetch(ajax.url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams(params).toString(),
    })
        .then((response) => {
          return response.text();
        })
        .then((response) => {
          this._list.innerHTML = response;

          if (!response) {
            this._showMoreButton.classList.add('hidden');
          } else {
            if (this._list.querySelectorAll('[data-cards-item]').length <= 8) {
              this._showMoreButton.classList.add('hidden');
            } else {
              if (this._showMoreButton.classList.contains('hidden')) {
                this._showMoreButton.classList.remove('hidden');
              }
            }
          }
        });
  }
}
